import { PropsWithChildren } from "react";

export const ProblemWrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="flex h-96 border border-dm-charcoal-100 bg-white px-2 py-4 sm:rounded-lg sm:p-5 lg:p-8">
    {children}
  </div>
);
